module.exports = __webpack_public_path__ + "img/image62.139ea7f1.jpg";